import controllerAside from './controllerAside.js';
import scrollToMain from './scrollToMain.js';
import controllerSliderBtn from './controllerSliderBtn.js';
import controllerTab from './controllerTab.js';

export default () => {
    document.addEventListener('click', function(e) {
        let el = e.target;

        if (el.classList.contains('burger')) {
            document.querySelector('.nav').classList.toggle('triggered');
            el.classList.toggle('triggered');
            document.querySelector('body').classList.toggle('no-scroll');
        }

        if (el.classList.contains('lang')) {
            document.querySelector('.nav-lang').classList.toggle('triggered');
        }

        if (el.classList.contains('btn-aside')){
            controllerAside(el);
        }

        if (el.classList.contains('close-nav-aside')){
            if(document.querySelector('.nav-aside').classList.contains('triggered')){
                document.querySelector('.nav-aside').classList.remove('triggered');
            }
        }

        if (el.classList.contains('lang-footer')){
            document.querySelector('.nav-lang-footer').classList.toggle('triggered');
            el.classList.toggle('triggered');
        }

        if (el.classList.contains('btn-scroll')){
            scrollToMain()
        }

        if (el.classList.contains('btn-slider')){
            controllerSliderBtn(el)
        }

        if (el.classList.contains('btn-tab')){
            controllerTab(el)
        }
    });
}